



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

export interface FormApiConfig {
  getEndpoint: string;
  saveEndpoint: string;
  deleteEndpoint: string;
}

@Component
export default class FormApiConfigDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) apiConfig!: FormApiConfig;

  public config: FormApiConfig = {
    getEndpoint: "",
    saveEndpoint: "",
    deleteEndpoint: "",
  };

  public get internalShow(): boolean {
    return this.value;
  }

  public set internalShow(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("value")
  onValueChanged(newVal: boolean) {
    if (newVal) {
      // Load config when opening
      this.config = { ...this.apiConfig };
    }
  }

  public save() {
    this.$emit("save", this.config);
    this.close();
  }

  public close() {
    this.$emit("input", false);
  }
}
